/**
 * Orquestrador de documentos CPF/CNPJ. Espelha o objeto de valor CpfCnpj
 * do backend. Não contém regras próprias: classifica o documento e delega
 * a normalização para `cpf.js` ou `cnpj.js`.
 */

import cpf from './cpf'
import cnpj from './cnpj'

/**
 * Indica se o documento deve ser tratado como CNPJ: valor normalizado com
 * mais de 11 caracteres. Não afirma validade do documento.
 *
 * @param {string|number|null|undefined} valor
 * @returns {boolean}
 */
export const deveSerTratadoComoCnpj = (valor) => {
  const cnpjNormalizado = cnpj.normalizarCnpj(valor)

  return !!cnpjNormalizado && cnpjNormalizado.length > 11
}

/**
 * Normaliza um documento CPF ou CNPJ. Delega para a normalização de CNPJ
 * (preserva letras) ou de CPF (apenas dígitos) conforme a classificação.
 *
 * @param {string|number|null|undefined} valor
 * @returns {string|null}
 */
export const normalizar = (valor) => {
  if (deveSerTratadoComoCnpj(valor)) {
    return cnpj.normalizarCnpj(valor)
  }

  return cpf.normalizarCpf(valor)
}

export default {
  normalizar,
  deveSerTratadoComoCnpj
}
